import { useEffect, useState } from 'react';
import {
  hasUnsavedWork,
  registerUnsavedWork,
  subscribeToUnsavedWork,
} from '../utils/unsavedWork';

/**
 * Declare that this component is holding unsaved work while `active` is true.
 *
 * Registering blocks the PWA update banner and arms the `beforeunload` guard —
 * see `src/utils/unsavedWork.js` for why both exist. Registration is released
 * automatically when `active` goes false or the component unmounts.
 */
export function useUnsavedWork(active, label) {
  useEffect(() => {
    if (!active) return undefined;
    return registerUnsavedWork(label);
  }, [active, label]);
}

/** Subscribe to whether *anything* in the app is holding unsaved work. */
export function useHasUnsavedWork() {
  const [present, setPresent] = useState(hasUnsavedWork);

  useEffect(() => {
    const sync = () => setPresent(hasUnsavedWork());
    const unsubscribe = subscribeToUnsavedWork(sync);
    // Re-read on subscribe: a registration between the initial render and this
    // effect would otherwise be missed until the next change.
    sync();
    return unsubscribe;
  }, []);

  return present;
}

export default useUnsavedWork;
